import { render, staticRenderFns } from "./CameraCapture.vue?vue&type=template&id=904f5318&"
import script from "./CameraCapture.vue?vue&type=script&lang=js&"
export * from "./CameraCapture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports